import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { CornerRadiusModel } from '~/core/models';

const cornerRadiiService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCornerRadii: builder.query<
      CornerRadiusModel[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: `${ApiUrl.CORNER_RADII}`,
        method: 'GET',
        params,
      }),
      transformResponse: (data: CornerRadiusModel[] | '' | null) =>
        data ? data : [],
    }),
  }),
});

export const { useFetchCornerRadiiQuery, useLazyFetchCornerRadiiQuery } =
  cornerRadiiService;
